export default {
  zh: {
    titleText:'Search room & user',
    enterID:"User's Id",
    find:"Find",
    userText:"User",
    roomText:"Room",
    notFound:"Not Found",
    webLink:"Web Link",
    sendVip:"Send VIP",
    selectVIP:"Select VIP Level",
    InputId:"Step 1 - Input the User ID",
    InputDays:"Input the days",
    InputDaysDes:"Step 2 - The effective days of VIP",
    SelectDay:"Step 3 - Select the VIP Level",
    send:"Send",
    PleaseSelectUserId:"Please enter the user ID and search",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
  },
  en: {
    titleText:'Search room & user',
    enterID:"User's Id",
    find:"Find",
    userText:"User",
    roomText:"Room",
    notFound:"Not Found",
    webLink:"Web Link",
    sendVip:"Send VIP",
    selectVIP:"Select VIP Level",
    InputId:"Step 1 - Input the User ID",
    InputDays:"Input the days",
    InputDaysDes:"Step 2 - The effective days of VIP",
    SelectDay:"Step 3 - Select the VIP Level",
    send:"Send",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
  },
  ar: {
    titleText:'بحث الغرف والمستخدم',
    enterID:"User's Id",
    find:"وجد",
    userText:"مستخدم",
    roomText:"غرفة",
    notFound:"غير متوفر",
    webLink:"Web Link",
    sendVip:"Send VIP",
    selectVIP:"Select VIP Level",
    InputId:"Step 1 - Input the User ID",
    InputDays:"Input the days",
    InputDaysDes:"Step 2 - The effective days of VIP",
    SelectDay:"Step 3 - Select the VIP Level",
    send:"Send",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
  },
  tr: {
    titleText:'Oda ve Kullanıcı ara',
    enterID:"Kullanıcı id ve Oda id",
    find:"Bul",
    userText:"kullanıcı",
    roomText:"oda",
    notFound:"Bulunamadı",
    webLink:"Web Link",
    sendVip:"Send VIP",
    selectVIP:"Select VIP Level",
    InputId:"Step 1 - Input the User ID",
    InputDays:"Input the days",
    InputDaysDes:"Step 2 - The effective days of VIP",
    SelectDay:"Step 3 - Select the VIP Level",
    send:"Send",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
  },
  pt:{
    titleText: 'Buscar sala e usuário',
    enterID: 'ID do usuário',
    find: 'Buscar',
    userText: 'Usuário',
    roomText: 'Sala',
    notFound: 'Não encontrado',
    webLink: 'Link da web',
    sendVip: 'Enviar VIP',
    selectVIP: 'Selecionar nível VIP',
    InputId: 'Passo 1 - Digite o ID do usuário',
    InputDays: 'Digite os dias',
    InputDaysDes: 'Passo 2 - Os dias efetivos do VIP',
    SelectDay: 'Passo 3 - Selecione o nível VIP',
    send: 'Enviar',
    PleaseSelectUserId: 'Por favor, insira o ID do usuário e pesquise',
    PleaseSelectVIP: 'Por favor, selecione o nível VIP',
    PleaseEnterDays: 'Por favor, insira os dias do VIP',
    limit30: 'O número de dias não pode exceder 30',
    success: 'Envio bem-sucedido'
  },
  id:{
    titleText: 'Cari kamar & pengguna',
    enterID: 'ID Pengguna',
    find: 'Temukan',
    userText: 'Pengguna',
    roomText: 'Kamar',
    notFound: 'Tidak Ditemukan',
    webLink: 'Tautan Web',
    sendVip: 'Kirim VIP',
    selectVIP: 'Pilih Level VIP',
    InputId: 'Langkah 1 - Masukkan ID Pengguna',
    InputDays: 'Masukkan hari',
    InputDaysDes: 'Langkah 2 - Hari VIP yang efektif',
    SelectDay: 'Langkah 3 - Pilih Level VIP',
    send: 'Kirim',
    PleaseSelectUserId: 'Harap masukkan ID pengguna dan cari',
    PleaseSelectVIP: 'Harap pilih level VIP',
    PleaseEnterDays: 'Harap masukkan jumlah hari VIP',
    limit30: 'Jumlah hari tidak boleh melebihi 30',
    success: 'Kirim berhasil',
  },
   uz:{
    "titleText": "Xonani va foydalanuvchini qidiring",
    "enterID": "Foydalanuvchi identifikatori",
    "find": "Topish",
    "userText": "Foydalanuvchi",
    "roomText": "Xona",
    "notFound": "Topilmadi",
    "webLink": "Veb-havola",
    "sendVip": "VIP yuborish",
    "selectVIP": "VIP darajasini tanlang",
    "InputId": "1-qadam - Foydalanuvchi identifikatorini kiriting",
    "InputDays": "Kunlarni kiriting",
    "InputDaysDes": "2-qadam - VIP amal qilish muddati",
    "SelectDay": "3-qadam - VIP darajasini tanlang",
    "send": "Yuborish",
    "PleaseSelectUserId": "Iltimos, foydalanuvchi identifikatorini kiriting va qidiring",
    "PleaseSelectVIP": "Iltimos, VIP darajasini tanlang",
    "PleaseEnterDays": "Iltimos, VIP kunlarini kiriting",
    "limit30": "Kunlar soni 30 dan oshmasligi kerak",
    "success": "Muvaffaqiyatli yuborildi"
    },
    ru:{
    "titleText": "Поиск комнаты и пользователя",
    "enterID": "Идентификатор пользователя",
    "find": "Найти",
    "userText": "Пользователь",
    "roomText": "Комната",
    "notFound": "Не найдено",
    "webLink": "Веб-ссылка",
    "sendVip": "Отправить VIP",
    "selectVIP": "Выбрать уровень VIP",
    "InputId": "Шаг 1 - Введите идентификатор пользователя",
    "InputDays": "Введите количество дней",
    "InputDaysDes": "Шаг 2 - Срок действия VIP",
    "SelectDay": "Шаг 3 - Выберите уровень VIP",
    "send": "Отправить",
    "PleaseSelectUserId": "Пожалуйста, введите идентификатор пользователя и выполните поиск",
    "PleaseSelectVIP": "Пожалуйста, выберите уровень VIP",
    "PleaseEnterDays": "Пожалуйста, введите количество дней VIP",
    "limit30": "Количество дней не может превышать 30",
    "success": "Успешно отправлено"
    },
    fa:{
    "titleText": "جستجوی اتاق و کاربر",
    "enterID": "شناسه کاربر",
    "find": "یافتن",
    "userText": "کاربر",
    "roomText": "اتاق",
    "notFound": "یافت نشد",
    "webLink": "لینک وب",
    "sendVip": "ارسال VIP",
    "selectVIP": "انتخاب سطح VIP",
    "InputId": "مرحله ۱ - وارد کردن شناسه کاربر",
    "InputDays": "وارد کردن تعداد روزها",
    "InputDaysDes": "مرحله ۲ - مدت اعتبار VIP",
    "SelectDay": "مرحله ۳ - انتخاب سطح VIP",
    "send": "ارسال",
    "PleaseSelectUserId": "لطفاً شناسه کاربر را وارد کرده و جستجو کنید",
    "PleaseSelectVIP": "لطفاً سطح VIP را انتخاب کنید",
    "PleaseEnterDays": "لطفاً تعداد روزهای VIP را وارد کنید",
    "limit30": "تعداد روزها نباید از ۳۰ بیشتر باشد",
    "success": "ارسال موفقیت‌آمیز بود"
}




}



// WEBPACK FOOTER //
// src/pages/admin-control/guild/lang.js